import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { SettingsComponent } from './settings.component';
import { SettingsRoutingModule } from './settings-routing.module';
import { ZoomCallbackComponent } from './zoom-callback/zoom-callback.component';
import { ZoomIntegrationComponent } from './zoom-integration/zoom-integration.component';
import { AiSettingsComponent } from './ai-settings/ai-settings.component';
import { TimezoneSettingsComponent } from './timezone-settings/timezone-settings.component';
import { CalendarIntegrationComponent } from './calendar-integration/calendar-integration.component';
import { GroupVisibilitySettingsComponent } from './group-visibility-settings/group-visibility-settings.component';
import { NotificationSettingsComponent } from './notification-settings/notification-settings.component';
import { WelcomeVideoSettingsComponent } from './welcome-video-settings/welcome-video-settings.component';
import { SupervisorCardsSettingsComponent } from './supervisor-cards-settings/supervisor-cards-settings.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';



@NgModule({
  declarations: [
    SettingsComponent,
    ZoomCallbackComponent,
    ZoomIntegrationComponent,
    AiSettingsComponent,
    TimezoneSettingsComponent,
    CalendarIntegrationComponent,
    GroupVisibilitySettingsComponent,
    NotificationSettingsComponent,
    WelcomeVideoSettingsComponent,
    SupervisorCardsSettingsComponent,
  ],
  imports: [
    CommonModule,
    SettingsRoutingModule,
    SharedModule,
    MatSnackBarModule,
    MatProgressBarModule,
]
})
export class SettingsModule { }